import { render, staticRenderFns } from "./Despachos.vue?vue&type=template&id=32badb6c&scoped=true&"
import script from "./Despachos.vue?vue&type=script&lang=js&"
export * from "./Despachos.vue?vue&type=script&lang=js&"
import style0 from "./Despachos.vue?vue&type=style&index=0&id=32badb6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32badb6c",
  null
  
)

export default component.exports